/* eslint-disable @typescript-eslint/naming-convention */
export enum BodyContentTypesEnum {
    Text = 'Text',
    Image = 'Image',
    Video = 'Video'
}
